module.exports = __webpack_public_path__ + "8c4708454bcbc6c7f808e232783e4ebd.pdf";